/**
 * Contact
 */

import React from 'react';
import PropTypes from 'prop-types';
import './Contact.scss';

class Contact extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { contact } = this.props;
        const style = {
            backgroundImage: `url(${contact.image})`,
        };

        return (
            <div className="Contact">
                <div className="Contact__ImageContainer">
                    <div className="Contact__Image" style={style} />
                </div>
                <div className="Contact__Content">
                    <h2 className="Contact__Heading">
                        {contact.title.rendered}
                    </h2>
                    <div
                        className="Contact__Description"
                        dangerouslySetInnerHTML={{
                            __html: contact.content.rendered,
                        }}
                    />
                </div>
            </div>
        );
    }
}

Contact.defaultProps = {
    contact: {
        image: '',
        title: {
            rendered: '',
        },
        content: {
            rendered: '',
        },
    },
};

Contact.propTypes = {
    contact: PropTypes.object,
};

export default Contact;
